import script from "./newCharge.vue?vue&type=script&setup=true&lang=js"
export * from "./newCharge.vue?vue&type=script&setup=true&lang=js"

import "./newCharge.vue?vue&type=style&index=0&id=4b0f33ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0f33ae"]])

export default __exports__